import { msg } from "@lingui/core/macro";

export const durationSetRuleMessages = {
	name: msg({ message: "Duration of Stay" }),
	description: msg({ message: "Set the Permit to a fixed duration" }),
} as const;
